import { g as n } from "./common.utils-016769eb.js";
import { c as r } from "./createTheme-6e68f5ca.js";
const i = {
  common: {
    dark: "#000000",
    black: "#0F0F0F",
    white: "#FFFFFF",
    transparent: "transparent",
    lightSuccess: "#A9B466",
    light: "#404040",
    lightError: "#EB6920",
    legacyPrimary: "#fe7d32",
    legacySecondary: "#fd7e32",
    leagecyNav: "#FE975B",
    gray_75: "#757575"
  },
  backgrounds: {
    primary: "#EFF1FF",
    success: "#E8FFF0",
    lightSuccess: "#F5FDEE",
    warning: "#FFF8EE",
    lightError: "#FEF8ED",
    error: "#FFE9E9",
    dark: "#EFEFEF",
    light: "#F8F8F8",
    white: "#FFFFFF",
    dividerDark: "#EBEBEB",
    divider: "#D2D1D1",
    info: "#E2F5FE",
    overlay: "#31313180"
  },
  divider: "#DEDEDE",
  // alternative divider -> #EBEBEB
  primary: {
    main: "#3543BF",
    light: "#C2C7EC",
    dark: "#1F2A8D",
    lighter: "#EFF1FF",
    medium: "#C2C7EC",
    lightBlue: "#008CFF"
  },
  error: {
    main: "#C62828",
    light: "#FFEBEE",
    lighter: "#FFE9E9",
    dark: "#C62828"
  },
  success: {
    main: "#37BC8E",
    light: "#7CE3C0",
    lighter: "#E8F5E9",
    medium: "#81C784",
    dark: "#2E7D32",
    infoDefault: "#D78411"
  },
  warning: {
    main: "#F2A526",
    dark: "#D18508",
    light: "#FADCAC",
    lighter: "#FFF8EE"
  },
  gray: {
    main: "#4A4A4A",
    light: "#8B8B8B"
  },
  text: {
    primary: "#404040",
    // dark
    secondary: "#787878",
    // light
    link: "#0B61D9",
    dark: "#343434",
    disable: "#0006",
    lightSecondary: "#858585"
  },
  info: {
    main: "#3543BF"
  },
  graph: {
    accent1: "#0F8EDB",
    accent2: "#EB9071",
    accent3: "#F1CB6A",
    accent4: "#D565BB"
  },
  secondary: {
    main: "#008CFF"
  }
}, l = (t) => n(i, t, "inherit"), o = (t) => {
  const e = {
    fontStyle: "normal",
    color: t.text.primary
  };
  return {
    fontFamily: "Roboto",
    // Heading H1 - Bold 28px
    h1: {
      ...e,
      fontWeight: 700,
      fontSize: "28px",
      lineHeight: "42px"
    },
    // Heading H2 - Medium 24px
    h2: {
      ...e,
      fontWeight: 500,
      fontSize: "24px",
      lineHeight: "32px"
    },
    // Heading H3 - Medium 18px
    h3: {
      ...e,
      fontWeight: 500,
      fontSize: "18px",
      lineHeight: "27px"
    },
    // Sub heading text - regular 16PX
    subHeadingRegular: {
      ...e,
      fontWeight: 400,
      fontSize: "16px",
      lineHeight: "20px"
    },
    // Sub heading text - Medium 16PX
    subHeadingMedium: {
      ...e,
      fontWeight: 500,
      fontSize: "16px",
      lineHeight: "20px"
    },
    // Body text - Regular 14px
    body1: {
      ...e,
      fontWeight: 400,
      fontSize: "14px",
      lineHeight: "20px"
    },
    // Body text - Medium 14PX
    body2: {
      ...e,
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "20px"
    },
    // Body link - regular 14PX
    link: {
      ...e,
      fontSize: "14px",
      lineHeight: "20px",
      textDecoration: "underline",
      color: t.text.link,
      cursor: "pointer"
    },
    // Button text - Bold 14px
    buttonText: {
      ...e,
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "18px",
      letterSpacing: "0.01em",
      textTransform: "uppercase"
    },
    // Section heading - Medium 12px
    sectionHeading: {
      ...e,
      fontStyle: "normal",
      fontWeight: 400,
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0.02em",
      textTransform: "uppercase"
    },
    // Subtext - Regular 12px
    subtitle1: {
      ...e,
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0.02em"
    },
    // Subtext - Regular 10px
    subtitle2: {
      ...e,
      fontSize: "10px",
      lineHeight: "16px",
      fontWeight: 400,
      letterSpacing: "0.02em"
    },
    // Subtext - Medium 12px
    subtextMedium: {
      ...e,
      fontSize: "12px",
      lineHeight: "16px",
      letterSpacing: "0.02em",
      textTransform: "uppercase"
    },
    // Legends - Regular 10px
    legends: {
      ...e,
      fontSize: "10px",
      lineHeight: "14px",
      letterSpacing: "0.02em"
    },
    // Shout value - Bold 32px
    shoutValue: {
      ...e,
      fontSize: "32px",
      lineHeight: "42px",
      letterSpacing: "0.02em"
    }
  };
}, F = r({
  typography: (t) => o(t),
  palette: i,
  breakpoints: {
    keys: ["xs", "sm", "md", "lg", "xl"],
    values: {
      xs: 576,
      sm: 768,
      md: 992,
      lg: 1280,
      xl: 1440
    }
  }
});
export {
  l as g,
  F as t
};
//# sourceMappingURL=index-d77fce4f.js.map
